import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';

export default {
  name: 'selectCustomerComp',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  props: {
    appId: {
      type: String,
      required: false,
      default: ''
    }
  },
  mixins: [users],
  data: function () {
    return {
      showEmptyState: false,
      lang: '',
      active: 'first',
      first: false,
      second: false,
      firstStepError: null,

      customers: [],
      customersCols: [],
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      keyColumn: 'customerKey',
      noDataFound: false,

      searchCustomerKey: '',
      searchSurname: '',
      searchInitial: '',
      searchAddress: '',
      searchTelephoneNumber: '',
      searchIdNumber: '',
      searchPin: '',
      searchCellPhone: '',
      billingGroups: [],
      billingGroupSelected: '-1',
      consumerTypes: [],
      consumerTypeSelected: '-1',
    }
  },
  created() {
    this.getLookups();
    this.fillcustomersCols();
  },
  watch: {
    
  },
  methods: {
    getLookups() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };
      axios.post('/CaptureCustomerActivity/GetCustomersLookups', parameter)
        .then(response => {
          if (response.status == 200) {
            //console.log(response.data);
            response.data.billingGroups.forEach(c => {
              if (!c.value)
                c.value = -1;
            });
            this.billingGroups = response.data.billingGroups;

            response.data.consumerTypes.forEach(c => {
              if (!c.value)
                c.value = -1;
            });

            this.consumerTypes = response.data.consumerTypes;
          }
        })
        .catch(error => {
         this.$alertMsg(error.response.data);
        });
    },
    onSelectCustomer(info) {
      console.log(info);
      this.$emit('selectCustomerDone', info.data.customerKey);
    },
    applyFilter() {
      this.showEmptyState = false;
      this.getCustomers();
    },
    resetFilters() {
      this.customers = [];
      this.billingGroupSelected = '-1';
      this.customerTypeSelected = '-1';
      this.searchCustomerKey = '';
      this.searchSurname = '';
      this.searchInitial = '';
      this.searchAddress = '';
      this.searchTelephoneNumber = '';
      this.searchIdNumber = '';
      this.searchPin = '';
      this.searchCellPhone = '';
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getCustomers();
    },
    getCustomers() {
      var criteria = {
        customerKey: this.searchCustomerKey,
        billingGroup: this.billingGroupSelected,
        surname: this.searchSurname,
        initial: this.searchInitial,
        consumerType: this.consumerTypeSelected,
        address: this.searchAddress,
        telephoneNumber: this.searchTelephoneNumber,
        idNumber: this.searchIdNumber,
        pin: this.searchPin,
        cellPhone: this.searchCellPhone,
      };
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Filters: criteria,
        Options: this.options
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/CaptureCustomerActivity/GetCustomersList', parameter)
        .then(response => {
          if (response.status == 200) {
            console.log(response.data);

            if (response.data.items.length == 0) {
              this.customers = [];
              this.noDataFound = true;
            }
            else {
              this.customers = response.data.items;
              this.options.total = response.data.itemsCount;
              this.totalRow = response.data.itemsCount;
              this.noDataFound = false;
            }
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          this.customers = [];
          this.noDataFound = true;
          this.$alertMsg(error.response.data);
        })
        .finally(() => {
          if (!this.customers || this.customers.length == 0)
            this.$alertMsg(this.$t('common.noDataFound'), 1);
          else
            this.active = 'second';
        });
    },
    fillcustomersCols() {
      this.customersCols.push({ dataField: 'billingGroupStr', caption: this.$t('activities.billingGroup') });
      this.customersCols.push({ dataField: 'customerKey', caption: this.$t('activities.account') });
      this.customersCols.push({ dataField: 'surname', caption: this.$t('activities.name') });
      this.customersCols.push({ dataField: 'initial', caption: this.$t('activities.initial') });
      this.customersCols.push({ dataField: 'address', caption: this.$t('activities.address') });
      this.customersCols.push({ dataField: 'consumerTypeStr', caption: this.$t('activities.consumerType') });
      this.customersCols.push({ dataField: 'telephoneNumber', caption: this.$t('activities.telNo') });
      this.customersCols.push({ dataField: 'cellPhone', caption: this.$t('activities.cellPhone') });
      this.customersCols.push({ dataField: 'idNumber', caption: this.$t('activities.idNo') });
      this.customersCols.push({ dataField: 'pin', caption: this.$t('activities.pin') });
    }
  },
}
